import { apiGenerator } from '../../../framework/apis/apiGenerator';
import { env } from '../../../framework/utils/EnvUtils';
import { MatterSummaryGetResult } from '../../models/gen/matterSummaryGetResult';
import { MatterSummarySearchParam } from '../../models/gen/matterSummarySearchParam';
import { MatterSummarySearchResult } from '../../models/gen/matterSummarySearchResult';
import { useGenericMutation } from '../../utils/ReactQueryUtils';
import { queryOptions } from './base';

export const MATTER_SUMMARY_CONTEXT_NAMES = {
  POST_MATTER_SUMMARY_SEARCH: 'searchMatterSummary',
} as const;

const apis = apiGenerator();

/**
 * POST /matter-summary/search
 *
 * @param param -
 * @returns
 */
export const usePostMatterSummarySearch = () =>
  useGenericMutation(async (param: MatterSummarySearchParam) =>
    apis.post<MatterSummarySearchParam, MatterSummarySearchResult>(
      `${env.BASE_API_ENDPOINT}/matter-summary/search`,
      { ...queryOptions, data: param }
    )
  );
